import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sequence-editor-format-italic",
  "use": "icon-sequence-editor-format-italic-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-sequence-editor-format-italic\">\n    <path d=\"M5.28711 12.6204H6.62015M6.62015 12.6204H7.9532M6.62015 12.6204L9.28624 3.28906M9.28624 3.28906H7.9532M9.28624 3.28906H10.6193\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol